"use strict";
import { combineReducers } from "redux";
import addingComponent from "./reducers/adding_component";
import canvas from "./reducers/canvas";
import movingComponent from "./reducers/move_component";
import mode from "./reducers/modes";
import mousePos from "./reducers/mouse_position";
import hover from "./reducers/hover";
import selected from "./reducers/select_component";
import toneAdjustments from "./reducers/tone_adjustments";
import views from "./reducers/views";
import annotationMode from "./reducers/annotation_mode";
import documentPageId from "./reducers/document_page_id";
import textEditingMode from "./reducers/text_editing_mode";
const reducers = {
  mode,
  mousePos,
  views,
  addingComponent,
  movingComponent,
  hover,
  selected,
  canvas,
  annotationMode,
  documentPageId,
  toneAdjustments,
  textEditingMode
};
export default combineReducers(reducers);
